export class Shift {
	public is_cancelled: boolean;

	constructor() {
	}
}